import React from 'react';

import AccountSettingsFormFooter from 'shared/account-settings/components/account-settings-form-footer';
import {useFormikContext} from 'formik';
import {BaseProfileForm} from '../utils';
import useUserType from 'src/hooks/use-user-type/use-user-type';
import {UserCategory} from 'src/types/enums';

const deleteAccountText: Partial<Record<UserCategory, string>> = {
  student:
    'Are you sure you don’t want to keep your portfolio and a record of all of your hard earned achievements?',
  parent:
    "Are you sure you want to delete your account and remove access to your child's portfolio and achievements?",
  educator:
    'Are you sure you want to delete your account and lose access to your students’ progress and achievements?',
};

interface Props {
  onSubmitClick?: () => void;
}

const ProfileFormFooter = <T extends BaseProfileForm>({onSubmitClick}: Props) => {
  const formik = useFormikContext<T>();
  const {userCategory} = useUserType();

  const handleSubmit = async () => {
    if (onSubmitClick) {
      onSubmitClick();
    }
    await formik.submitForm();
  };

  return (
    <AccountSettingsFormFooter
      deleteAccountText={deleteAccountText[userCategory]}
      submitting={formik.isSubmitting}
      includeDelete
      handleSubmit={handleSubmit}
      studentId={formik.values._id}
      disabled={formik.isSubmitting}
    />
  );
};

export default ProfileFormFooter;
